import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class TestingService {
    constructor(private httpClient: HttpClient) { }

    sendEmail(x: {EmailAddress: String}) {
        return this.httpClient.post('api/settings/sendemailtest', x).toPromise();
    }
}